import { forwardRef } from 'react'

import { Icon } from '@chakra-ui/react'

const createChakraIcon = (path: string) =>
  forwardRef<SVGSVGElement, Record<string, unknown>>((props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" {...props}>
      <path fill="currentColor" d={path} />
    </Icon>
  ))

export const AddIcon = createChakraIcon('M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z')
export const CheckCircleIcon = createChakraIcon(
  'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z',
)
export const ChevronDownIcon = createChakraIcon('M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z')
export const ChevronRightIcon = createChakraIcon('M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z')
export const CloseIcon = createChakraIcon(
  'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z',
)
export const DeleteIcon = createChakraIcon(
  'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z',
)
export const DownloadIcon = createChakraIcon('M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z')
export const WarningIcon = createChakraIcon('M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z')
export const WarningTwoIcon = createChakraIcon(
  'M12.003 21.43a1.53 1.53 0 0 1-1.52-1.52v-.07a1.53 1.53 0 0 1 1.52-1.52h.02a1.53 1.53 0 0 1 1.52 1.52v.07a1.53 1.53 0 0 1-1.52 1.52h-.02zm-.86-19.85a1.09 1.09 0 0 1 1.73 0l8.1 12a1.1 1.1 0 0 1-1.45 1.54l-1.59-.84-1.7 6.87a1.19 1.19 0 0 1-.57.74 1.16 1.16 0 0 1-1.29-.14l-8.79-7.42a1.1 1.1 0 0 1 0-1.69l5.24-4.21-2.1-2.69a1.09 1.09 0 0 1-.02-1.27z',
)
